import ListingMessagesPanel from '../components/agent/ListingMessagesPanel';
import PageRefinedHero from '../components/layout/PageRefinedHero';

const MessagesPage = ({
  user,
  currentUid,
  isLoggedIn,
  setPage,
  addToast,
  onUnreadChange,
  onNotifyNewMessages,
  onActiveConversationChange,
  initialConversationId = null,
  onOpenListing
}) => {
  if (!isLoggedIn) {
    return (
      <div className="coown-page coown-page--hero">
        <PageRefinedHero
          badge="Inbox"
          title="Your"
          titleAccent="messages"
          subtitle="Sign in to chat with listing agents and reply to buyers interested in your properties."
          benefits={[
            { icon: 'fas fa-building', title: 'Listing inquiries', subtitle: 'Questions from potential buyers' },
            { icon: 'fas fa-user-tie', title: 'Agent chat', subtitle: 'Connect with property listers' },
            { icon: 'fas fa-bell', title: 'Stay in the loop', subtitle: 'Unread alerts in the menu' },
          ]}
        />
        <div className="coown-page-body coown-page-body--narrow">
          <div className="coown-page-empty">
            <i className="fas fa-comments coown-page-empty__icon" aria-hidden="true"></i>
            <h3>Sign in to view messages</h3>
            <p>Your conversations with agents and buyers appear here after you log in.</p>
            <button type="button" className="btn btn-primary" onClick={() => setPage?.('login')}>Sign in</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="coown-page coown-page--hero">
      <PageRefinedHero
        badge="Inbox"
        title="Your"
        titleAccent="messages"
        subtitle="Chat with listing agents or reply to buyers interested in your properties — all in one place."
        benefits={[
          { icon: 'fas fa-inbox', title: 'Unified inbox', subtitle: 'Buyer and lister threads together' },
          { icon: 'fas fa-reply', title: 'Quick replies', subtitle: 'Respond without leaving CoOwn' },
          { icon: 'fas fa-home', title: 'Listing context', subtitle: 'Jump to the property from chat' },
        ]}
      />

      <div className="coown-page-body coown-page-body--messages">
        <ListingMessagesPanel
          user={user}
          currentUid={currentUid}
          addToast={addToast}
          onUnreadChange={onUnreadChange}
          onNotifyNewMessages={onNotifyNewMessages}
          onActiveConversationChange={onActiveConversationChange}
          initialConversationId={initialConversationId}
          onOpenListing={onOpenListing}
        />
      </div>
    </div>
  );
};

export default MessagesPage;
